export default __webpack_public_path__ + "static/media/1_SatışÖrnekExcelData.ede6b71d.xlsx";